import { DESKTOP_HISTORY_LIMIT, MOBILE_HISTORY_LIMIT } from 'app/constants/historyLimits'

export const convertActivities = activities => {
  let isPreviousCompleted
  let line
  let y = 1
  return activities.reduce((acc, activity, index, activities) => {
    const completed = activity.completed
    let x = index + 1
    const isLast = activities.length - 1 === index
    const isStreak = completed === isPreviousCompleted
    if (line) {
      line.x2 = x
      if (isPreviousCompleted) {
        y++
        line.y2 = y
      }
    }
    if (!isLast) {
      if (isStreak) {
        return acc
      } else {
        line = { completed, x1: x, x2: x, y1: y, y2: y }
        acc.push(line)
      }
    } else {
      if (isStreak && acc[acc.length - 1]) {
        acc[acc.length - 1].x2 = x + 1
        acc[acc.length - 1].y2 = completed ? y + 1 : y
      } else {
        line = { completed, x1: x, x2: x + 1, y1: y, y2: completed ? y + 1 : y }
        acc.push(line)
      }
    }
    isPreviousCompleted = completed
    return acc
  }, [])
}

export const rotate = (y, height) => -y + height

export const getGraphElements = ({ activities, isMobile, innerWidth, innerHeight }) => {
  const limit = isMobile ? MOBILE_HISTORY_LIMIT : DESKTOP_HISTORY_LIMIT
  const xStep = innerWidth / limit
  const yStep = innerHeight / limit
  const xOffset = 0
  const yOffset = -5
  const graphLines = convertActivities(activities)
  const graphElements = graphLines.map((item, index, array) => {
    return {
      coordinates: {
        x1: (item.x1 - 1) * xStep + xOffset,
        x2: (item.x2 - 1) * xStep + xOffset,
        y1: rotate((item.y1 - 1) * yStep - yOffset, innerHeight),
        y2: rotate((item.y2 - 1) * yStep - yOffset, innerHeight),
      },
      completed: item.completed,
      activitiesCompleted: item.y2 - item.y1,
      isLast: index === array.length - 1,
    }
  })
  return graphElements
}
